import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateProjectStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const ActiveModal = ({ project, setShow, handleStatus }) => {
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handleActive = async prop => {
    await handleStatus(prop);
    dispatch(getRealEstateProjectStats(realEstate.id));
    handleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon="fa-power-off"
          size="1x"
          title="Activar"
          style={{ marginRight: 8, color: '#00d97e' }}
        />

        <Modal.Title>Activar emprendimiento</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          El emprendimiento de dirección{' '}
          <b>
            {project.location.street} {project.location.number}
          </b>{' '}
          se activará y los clientes podrán verlo y consultar por el.
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?
        </div>

        <ModalButtonsContainer>
          <ButtonClose text="Cancelar" funcion={handleClose} />

          <ButtonAccept
            text="Confirmar"
            funcion={handleActive}
            data={{ id: project._id, status: 'published' }}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

ActiveModal.propTypes = {
  project: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default ActiveModal;
